import React, { useContext, useEffect, useRef, useState } from "react";
// import "../../styles/component/popup/CustomizeTabsModal.css";

import Style from "./style.module.css";

import { useFormik } from "formik";
import * as yup from "yup";
// import XCloseIcon from "../../component/icons/x-close";
import Select from "react-select";
import { Trash2 } from "lucide-react";
import { useApiCall } from "../../custom-hooks/api-call";
import { GlobalContext } from "../../../context/Context";
import Tooltip from "../../ui/tooltip";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
  SelectSearch,
} from "../../form/form-layout";
import LeftSidePopupLayout from "../../popup/modal-layout";
import XCloseIcon from "../../icons/x-close";

const BulkEdit = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  users = [],
  BrandList = [],
  Countries = [],
  UsersList = [],
}) => {
  const apiCall = useApiCall();

  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);

  const initialMainId = null;
  const initialSubId = null;
  // const initialPackageId = CustomerData?.deal_package
  //   ? Number(metas.deal_package)
  //   : null;

  let { state, dispatch } = useContext(GlobalContext);

  const userOptions = UsersList.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const countryOptions = Countries?.map((country) => ({
    value: country.country_code,
    label: country.country_name,
  }));

  const brandOptions = BrandList?.map((mp) => ({
    value: mp.brandsid,
    label: mp.brandname,
  }));

  const handleLeadSource = (selectId) => {
    const selectedBrandId = selectId;
    // console.log(selectedBrandId);

    // formik.setFieldValue("deal_package", selectedPackageId);

    // Find selected package
    const selected = BrandList?.find((pkg) => pkg?.brandsid == selectedBrandId);

    // console.log("selected", selected);

    // Set selected package features
    // if (selected) {
    //   setBrandUrl(selected?.brandurl || "");
    // } else {
    //   setBrandUrl("");
    // }
  };

  const AddField = () => {
    const newFields = [
      ...formik.values.extra_meta,
      { meta_key: "", meta_value: "" },
    ];
    formik.setFieldValue("extra_meta", newFields);
  };

  const DeleteField = (index) => {
    const newFields = formik.values.extra_meta.filter((_, i) => i !== index);
    formik.setFieldValue("extra_meta", newFields);
  };

  const validationSchema = yup.object({
    // customerFullName: yup.string().required("This Field is Required"),
    // industry: yup.string().required("This Field is Required"),
    // brandid: yup.string().required("This Field is Required"),
    // main_product: yup.string().required("This Field is Required"),
    // product: yup.string().when("main_product", {
    //   is: (val) => Number(val) !== 9,
    //   then: (schema) => schema.required("This Field is Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // // country: yup.string().required("country is required"),
    // state: yup.string().required("This Field is Required"),
    // city: yup.string().required("This Field is Required"),
    // lead_assigned: yup
    //   .array()
    //   .of(yup.string())
    //   .min(1, "This Field is Required")
    //   .required("This Field is Required"),

    main_product: yup.string().nullable(),

    product: yup.string().when("main_product", {
      is: (val) => val && val !== "",
      then: (schema) => schema.required("Sub Product is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      // customerFullName: "",
      industry: "",
      brandid: "",
      main_product: initialMainId || "",
      product: "",
      subject: "",
      message: "",
      country: "",
      state: "",
      city: "",
      lead_assigned: "",
      extra_meta: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let extra_meta = values.extra_meta.map((item) => ({
        key: item.meta_key,
        value: item.meta_value,
      }));

      extra_meta.push({
        key: "main_product",
        value: values.main_product,
      });

      // const data = {
      //   lead_ids: users?.lead_ids,
      //   user_ids: users?.user_ids,
      //   // customerFullName: values.customerFullName || "",
      //   country: values.country,
      //   product: values.main_product !== 9 ? Number(values.product) : 9,
      //   brandid: Number(values.brandid),
      //   lead_assigned: values?.lead_assigned?.map((id) => Number(id)),
      //   city: values.city,
      //   state: values.state,
      //   industry: values.industry,
      //   message: values.message,
      //   extra_meta: extra_meta,
      // };

      const data = {
        lead_ids: users?.lead_ids,
        user_ids: users?.user_ids,

        ...(values.country && { country: values.country }),

        ...(values.main_product && {
          product: values.main_product !== 9 ? Number(values.product) : 9,
        }),

        ...(values.brandid && { brandid: Number(values.brandid) }),

        ...(values.lead_assigned?.length && {
          lead_assigned: values.lead_assigned.map((id) => Number(id)),
        }),

        ...(values.city && { city: values.city }),
        ...(values.state && { state: values.state }),
        ...(values.industry && { industry: values.industry }),
        ...(values.message && { message: values.message }),

        ...(extra_meta && { extra_meta }),
      };

      console.log("data", data);
      console.log("Extra", extra_meta);

      try {
        const apiRes = await apiCall({
          method: "post",
          url: "leads/edit-bulk-custom-lead",
          data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || "Request Submitted");
        onClose();
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  const isAnyFieldFilled = Object.values(formik.values).some((val) => {
    if (Array.isArray(val)) return val.length > 0;
    return val !== "" && val !== null && val !== undefined;
  });
  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {});
    } else if (initialSubId) {
      // loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    const id = option || "";

    formik.setFieldValue("main_product", id);

    formik.setFieldValue("product", "");

    setSubProducts([]);

    if (id) {
      await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option || "";
    formik.setFieldValue("product", id);
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid),
      ) === i,
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i,
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        key={1}
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head}`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Bulk Edit</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody} !relative`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3 `}>
                <FormArea>
                  {/* Name */}
                  {/* <FeildWraper width="100%">
                    <FormLabel required>Name</FormLabel>
                    <input
                      name="customerFullName"
                      value={formik.values.customerFullName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Name"
                    />
                    {formik.touched.customerFullName &&
                      formik.errors.customerFullName && (
                        <FeildError>
                          {formik.errors.customerFullName}
                        </FeildError>
                      )}
                  </FeildWraper> */}

                  {/* country */}
                  <FeildWraper width="100%">
                    <FormLabel required>Country</FormLabel>
                    <SelectSearch
                      menuPosition="fixed"
                      name="country"
                      placeholder="- Select country -"
                      onChange={(val) => {
                        formik.setFieldValue("country", val);
                      }}
                      value={formik.values.country}
                      options={countryOptions}
                    />
                    {formik.touched.country && formik.errors.country && (
                      <FeildError>{formik.errors.country}</FeildError>
                    )}
                  </FeildWraper>

                  {/* lead_assigned */}

                  <FeildWraper>
                    <FormLabel required>Assigned</FormLabel>

                    <SelectSearch
                      name="lead_assigned"
                      multiple
                      placeholder="- Select Users -"
                      onChange={(val) => {
                        formik?.setFieldValue("lead_assigned", val);
                      }}
                      value={formik?.values.lead_assigned}
                      options={userOptions}
                      onBlur={() =>
                        formik.setFieldTouched("lead_assigned", true, true)
                      }
                      menuPosition="fixed"
                    />

                    {formik.touched.lead_assigned &&
                      formik.errors.lead_assigned && (
                        <FeildError>{formik.errors.lead_assigned}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Brand */}

                  <FeildWraper>
                    <FormLabel required>Brand</FormLabel>

                    <SelectSearch
                      name="brandid"
                      placeholder="- Select Brand -"
                      onChange={(val) => {
                        formik?.setFieldValue("brandid", val);
                        handleLeadSource(val);
                      }}
                      value={formik?.values.brandid}
                      options={brandOptions}
                      onBlur={() =>
                        formik.setFieldTouched("brandid", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.brandid && formik.errors.brandid && (
                      <FeildError>{formik.errors.brandid}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Main Product */}

                  <FeildWraper
                    width={formik.values.main_product == 9 ? `100%` : `50%`}
                  >
                    <FormLabel required>Main Product</FormLabel>

                    <SelectSearch
                      name="main_product"
                      placeholder="- Select Product -"
                      onChange={handleMainSelect}
                      value={formik?.values.main_product}
                      options={mainOptions}
                      onBlur={() =>
                        formik.setFieldTouched("main_product", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.main_product &&
                      formik.errors.main_product && (
                        <FeildError>{formik.errors.main_product}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Sub product */}

                  {formik.values.main_product !== 9 ? (
                    <FeildWraper>
                      <FormLabel required>Sub Product</FormLabel>

                      <SelectSearch
                        name="product"
                        placeholder={
                          formik.values.main_product
                            ? "- Select Sub Product -"
                            : "Please select a product first"
                        }
                        onChange={(val) => {
                          formik.setFieldValue("product", val ? val : "");
                          handleSubSelect(val);
                        }}
                        isDisabled={!formik.values.main_product}
                        value={formik?.values.product}
                        options={subOptions}
                        onBlur={() =>
                          formik.setFieldTouched("product", true, true)
                        }
                        menuPosition="fixed"
                      />
                      {formik.touched.product && formik.errors.product && (
                        <FeildError>{formik.errors.product}</FeildError>
                      )}
                    </FeildWraper>
                  ) : null}

                  {/* state */}
                  <FeildWraper>
                    <FormLabel required>State</FormLabel>
                    <input
                      name="state"
                      value={formik.values.state}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter State"
                    />
                    {formik.touched.state && formik.errors.state && (
                      <FeildError>{formik.errors.state}</FeildError>
                    )}
                  </FeildWraper>

                  {/* city */}
                  <FeildWraper>
                    <FormLabel required>City</FormLabel>
                    <input
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter City"
                    />
                    {formik.touched.city && formik.errors.city && (
                      <FeildError>{formik.errors.city}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Subject */}
                  <FeildWraper>
                    <FormLabel> Subject</FormLabel>
                    <input
                      name="subject"
                      value={formik.values.subject}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter  Subject"
                    />
                  </FeildWraper>

                  {/* Industry */}

                  <FeildWraper>
                    <FormLabel required> Industry</FormLabel>
                    <input
                      name="industry"
                      value={formik.values.industry}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter  Industry"
                    />
                    {formik.touched.industry && formik.errors.industry && (
                      <FeildError>{formik.errors.industry}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Message */}
                  <FeildWraper width="100%">
                    <FormLabel>Message</FormLabel>
                    <input
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Message"
                    />
                  </FeildWraper>

                  <FormLineBreak />

                  {formik?.values?.extra_meta.length > 0 && (
                    <div className={Style.tDividerWrapper}>
                      <div
                        className={Style.horizontalLine}
                        aria-hidden="true"
                      />
                      <div className={`${Style.dividerLabel} px-4`}>
                        Additional Fields
                      </div>
                    </div>
                  )}

                  {/*  Add more */}

                  <FeildWraper width="100%">
                    {formik?.values?.extra_meta.map((field, index) => (
                      <div className={`w-full flex gap-3`} key={index}>
                        {/* key */}

                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_key`}
                          value={formik.values.extra_meta[index].meta_key}
                          onChange={formik.handleChange}
                          placeholder="key"
                        />

                        {/* value */}

                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_value`}
                          value={formik.values.extra_meta[index].meta_value}
                          onChange={formik.handleChange}
                          placeholder="value"
                        />

                        <Tooltip
                          key={`${index}-asideBottomItems`}
                          className={`${Style.Tooltip}`}
                          boxClassName={Style.TooltipBox}
                          content="Delete Field"
                          position={"bottom center"}
                        >
                          <div
                            onClick={() => DeleteField(index)}
                            className="p-3 text-red-600"
                          >
                            <Trash2 size={18} />
                          </div>
                        </Tooltip>
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={AddField}
                      className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                    >
                      + Add Field
                    </button>
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            disabled={!isAnyFieldFilled}
            className={`${Style.dcmb__submit} ${
              !isAnyFieldFilled
                ? "!cursor-not-allowed  !bg-[#335CFF] !hover:bg-[#2c50df] !text-white opacity-50"
                : "cursor-pointer !bg-[#335CFF] !hover:bg-[#2c50df] !text-white"
            }`}
          >
            Apply
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default BulkEdit;
